import React, { Fragment , useState, useEffect } from 'react';
import blogs from '../../api/blogs'
import { useParams } from 'react-router-dom';
import BlogSingle from '../../components/BlogDetails/BlogDetails';
import Bg from '../../images/bg/page_bg01.jpg'
import icon from '../../images/icon/cap.svg'
import Image1 from '../../images/hero/cd-img02.png'
import Image2 from '../../images/shape/brd_shape.png'
import Image3 from '../../images/gallery/cd-image.jpg'
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import CtaSection from '../../components/CtaSection/CtaSection';
import Footer from '../../components/data-solutions-components/Footer/Footer';
import Loader from '../../components/Loader/Loader';
import parse from 'html-react-parser';
const BlogDetails = (props) => {
    const { slug } = useParams();
    const pageId = decodeURIComponent(slug);
    
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    
    useEffect(() => {
        if (pageId) {
            fetch(`https://script.google.com/macros/s/AKfycbyYDcg8tlwvtjU3zx_owD0ihWw_ffUFjhLIWrTaWqC-6CQjCxUw-K8kUWmBEUd2YKQ/exec?blogdetail=${pageId}`)
                .then((response) => {
                    if (!response.ok) {
                        setIsError(true);
                        return;
                    }
                    return response.json();
                })
                .then((data) => {
                    // If data is empty or no valid blog found
                    if (!data || data.length === 0) {
                        setIsError(true);
                    } else {
                        setData(data[0]); // Assuming data is an array, and we take the first item
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setIsError(true);
                })
                .finally(() => setIsLoading(false));
        } else {
            setIsError(true);
            setIsLoading(false);
        }
    }, [pageId]);
    
    // If loading data
    if (isLoading) {
        return <Loader />;
    }
    
    // If data is empty or error occurred
    if (isError) {
        return  (<section className="container d-flex justify-content-center align-items-center" style={{ height: '100vh' }}><h1>404 - Not Found</h1></section>);
    }
  
    
    return (
        <Fragment>
            <Header />
            <main className="page_content blog-page">
                <section className="page-title  pt-200 pos-rel bg_img" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="container">
                        <div className="page-title-wrap sd-title-wrap">
                            <div className="row mt-none-30 align-items-end">
                                <div className="col-lg-9 mt-30">
                                    <div className="page-title-box">
                                        <span className="sub-title"><img src={icon} alt="" /> Blog details</span>
                                        <h2 className="title">{data.title}</h2>
                                      
                                    </div>
                                </div>
                                <div className="col-lg-3 mt-30">
                                    <div className="sd-right-img pos-rel">
                                        <img src={Image1} alt="" />
                                        <div className="sd-arrow-shape style-2">
                                            <img className="xbzoominzoomup" src={Image2} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <BlogSingle 
                otherData={data}
                />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogDetails;